module.exports = __webpack_public_path__ + "img/wa1e.6580fe64.jpg";